import Play from "../assets/media/play-icon.svg";
import { useEffect, useState } from "react";
import { getCurrentTimeInSeconds, timeToSeconds, to12HourFormat } from "../common/helper";
import { NavLink } from "react-router-dom";

const JackpotGames = ({ jackpotData }) => {
    const [markets, setMarkets] = useState([]);

    useEffect(() => {
        if (!jackpotData || !Array.isArray(jackpotData)) {
            return; // Don't proceed if data is invalid
        }

        const currentSeconds = getCurrentTimeInSeconds();

        const updatedMarkets = jackpotData.map((market) => {
            const closeBidLastSeconds = timeToSeconds(market.time);

            let status = "Closed for today";
            let isOpenForBidding = false;

            // Jackpot opens at midnight (00:00) and closes at market.time,
            // so it is "Running for open" only while now is before close time.
            if (currentSeconds < closeBidLastSeconds) {
                status = "Running for open";
                isOpenForBidding = true;
            }

            const marketTime = to12HourFormat(market.time);

            return {
                // ...market,
                time: market.time,
                _time: marketTime,
                // closeBidTime: closeBidTime12Hour,
                status: status,
                isOpenForBidding: isOpenForBidding,
                result: market.result
            };
        });

        setMarkets(updatedMarkets);
    }, [jackpotData]);

    return (
        <section className="container">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-heading-branded">
                            <span className="section-heading-branded__star" aria-hidden="true">⭐</span>
                            <h2 className="section-heading-branded__text mb-0">Jackpot Games</h2>
                            <span className="section-heading-branded__star" aria-hidden="true">⭐</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="row gap-3 justify-content-center">

                            {
                                markets.map((m, i) => {
                                    return <div className="gameCard__wrapper" key={i}>
                                        <div className="gameCard__firstSection">
                                            <div className="first__data">
                                                <span className="gameCard__name"> {m._time} </span>
                                                <span className="gameCard__result"> {m.result.formatted_result} </span>
                                                <span
                                                    className={
                                                        "gameCard__marketStatus " +
                                                        (m.isOpenForBidding
                                                            ? "gameCard__marketStatus--open"
                                                            : "gameCard__marketStatus--closed")
                                                    }
                                                >
                                                    {m.status}
                                                </span>
                                            </div>
                                            <div className={"play__btn " + (m.isOpenForBidding ? "play__btn--animate" : "")}>
                                                <img
                                                    alt={`Play Jackpot ${m._time}`}
                                                    loading="lazy"
                                                    width={13}
                                                    height={13}
                                                    decoding="async"
                                                    data-nimg={1}
                                                    src={Play}
                                                    style={{
                                                        color: m.isOpenForBidding ? "initial" : "transparent",
                                                        filter: m.isOpenForBidding ? "none" : "grayscale(100%)",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="gameCard__charts">
                                            <NavLink
                                                to={"/chart/jackpot/" + m.time + "?scrollToBottom=true"}
                                                className='gameCard__link'
                                            >
                                                Jodi Chart
                                            </NavLink>

                                        </div>
                                        <div className="result__time">
                                            <span>
                                                Open Bids : <strong> 12:00 AM </strong>
                                            </span>
                                            <span>
                                                Close Bids :<strong> {m._time} </strong>
                                            </span>
                                        </div>
                                    </div>
                                })
                            }

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default JackpotGames;
